module.exports = __webpack_public_path__ + "img/slide-3.a4db7406.jpg";